import { FormattedMessage } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import BoltIcon from '@flipster/react/icon/generated/BoltIcon';
import CandlestickIcon from '@flipster/react/icon/generated/CandlestickIcon';
import EarnIcon from '@flipster/react/icon/generated/EarnIcon';
import { css } from '@flipster/styled-system/css';
import { circle, flex, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

import bannerImage from './assets/banner.webp';

interface Props {
  onClickDetail: () => void;
}

export const PremiumEarnNudgeContents = ({ onClickDetail }: Props) => {
  return (
    <div className={stack({ gap: 10 })}>
      <img
        src={bannerImage.src}
        alt='get-premium-usdt'
        width={200}
        height={200}
        className={css({ alignSelf: 'center' })}
      />
      <div className={stack({ gap: 24 })}>
        <div className={stack({ gap: 12 })}>
          <p className={css({ textStyle: 'Title/M', color: 'inverse.white' })}>
            <FormattedMessage id='Earn.r260318.Pusdt_earn_yield_without_pausing_your_trade' />
          </p>
          <div>
            <TextButton
              as='button'
              color='accent'
              size='medium'
              label={<FormattedMessage id='Common.r251107.View_details' />}
              css={{ textAlign: 'center' }}
              onClick={onClickDetail}
            />
          </div>
        </div>
        <Item
          icon={<CandlestickIcon size={20} color={token('colors.background.accent.buy')} />}
          title={<FormattedMessage id='Earn.r260318.Pusdt_earn_while_you_trade' />}
          description={<FormattedMessage id='Earn.r260318.Pusdt_your_usdt_keeps_earning_even_while_used_as_margin' />}
        />
        <Item
          icon={<EarnIcon size={20} color={token('colors.background.accent.buy')} />}
          title={<FormattedMessage id='Earn.r260318.Pusdt_compounding_returns' />}
          description={<FormattedMessage id='Earn.r260318.Pusdt_daily_rewards_are_automatically_reinvested' />}
        />
        <Item
          icon={<BoltIcon size={20} color={token('colors.background.accent.buy')} />}
          title={<FormattedMessage id='Earn.r260318.Pusdt_withdraw_anytime_instantly' />}
          description={<FormattedMessage id='Earn.r260318.Pusdt_no_lockup_no_penalties_your_funds_are_always_yours' />}
        />
      </div>
    </div>
  );
};

const Item = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
}) => {
  return (
    <div className={flex({ gap: 16 })}>
      <div className={circle({ size: 40, bg: 'background.state.positive.tint' })}>{icon}</div>
      <div className={stack({ gap: 4 })}>
        <p className={css({ textStyle: 'Title/XS', color: 'content.default.level-5' })}>{title}</p>
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>{description}</p>
      </div>
    </div>
  );
};
